// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__17Yxm","footer":"ChangeClinic_footer__1apah"};